import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { CuttingCustomHoleSchema } from '../../../../models/cutting/cutting-custom-hole-schema.model';
import { FastenerSessionStorageManager, FastenerType } from '../fastener-session-storage-manager.helper';

@Component({
  selector: 'csl-custom-hole-schemas-list',
  templateUrl: './custom-hole-schemas-list.component.html',
  styleUrls: ['./custom-hole-schemas-list.component.scss'],
})
export class CustomHoleSchemasListComponent implements OnInit {
  lastSelectedId = 0;

  @Input() schemas: CuttingCustomHoleSchema[] = [];

  @Output() formChanged: EventEmitter<CuttingCustomHoleSchema> = new EventEmitter();

  constructor() {}

  ngOnInit(): void {
    const lastSelectedSS = FastenerSessionStorageManager.lastSelectedFastener;

    if (lastSelectedSS && lastSelectedSS.type === FastenerType.Hole) {
      this.lastSelectedId = lastSelectedSS.id;
    }
  }

  selectSchema(schema: CuttingCustomHoleSchema): void {
    this.formChanged.emit(schema);
  }
}
